import {html, css} from 'lit'
import App from 'bui/app/tabbar'
import './overview'
import './auftragsliste'
import './erneuern'
import './elements'
import './presenters'
// import './tools'
import './server'
import './components'
import './tools/docs'

customElements.define('demo-main', class extends App{

    static properties = {
        showModAuftragsliste: { type: Boolean },
        token: { type: Object }
    };

    static styles = [App.styles, css`
        :host {
            --b-app-tab-bar-bgd: var(--theme-bgd) !important;
        }
    `]

    constructor() {
        super();

        this.token = [];
        this.failedToken = [];

        this.showModAuftragsliste = false;
        this.showModErneuern = false;

        this._toggleViews('auftragsliste');
        this._toggleViews('erneuern')        
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('storage', this._onStorageChange);   
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('storage', this._onStorageChange);
    }

    _toggleViews(mod) {
        try {
            var data = [];
            if (mod === 'auftragsliste') {
                data = JSON.parse(localStorage.getItem('laportal-token'));
            }

            if (mod === 'erneuern') {
                data = JSON.parse(localStorage.getItem('laportal-failed-token'));
            }

        } catch (e) {
                data = [];
        }

        if (mod === 'auftragsliste') {
            this.token = data || [];
            this.showModAuftragsliste =
                this.token && this.token.length >= 1;
        }

        if (mod === 'erneuern') {
            this.failedToken = data || [];
            this.showModErneuern =
                this.failedToken && this.failedToken.length >= 1;
        }
    }
    

    _onStorageChange = (event) => {

        if (event.key === 'laportal-token') {  
            this._toggleViews('auftragsliste');            
        }
    
        if (event.key === 'laportal-failed-token') {
            this._toggleViews('erneuern');
        }
    }

    get views(){
        return html`
            demo-overview               
            ${this.showModAuftragsliste ? html`<mod-auftragsliste></mod-auftragsliste>` : '' }  
            ${this.showModErneuern ? html`<mod-erneuern></mod-erneuern>` : '' }
        `
    }
 
})

export default customElements.get('demo-main')